import { DodajProjektModel } from './dodajProjektModel';

export class EdytujProjektModel extends DodajProjektModel {
  id: string;
  czyNowyPlikZInstrukcja: boolean;
}
